/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */
/* eslint max-len: 0 */
import { SERIAL_SETUP, findPinMode } from './helpers';

export const serial_print = (block, generator) => {
  // Divergencia deliberada: el legacy usaba la clave 'setup_serial_9600' y emitía
  // dos Serial.begin al mezclar bloques; acá comparte 'setup_serial' con el resto.
  const content = generator.valueToCode(block, 'CONTENT', generator.ORDER_ATOMIC) || '0';
  generator.setups_['setup_serial'] = SERIAL_SETUP;
  return `Serial.print(${content});\n`;
};

export const serial_println = (block, generator) => {
  const content = generator.valueToCode(block, 'CONTENT', generator.ORDER_ATOMIC);
  const { code, pin } = findPinMode(content);
  generator.setups_['setup_serial'] = SERIAL_SETUP;
  // Sin salto adelante, al reves que serial_print: en el legacy cada uno
  // usaba una clave de setup distinta y por eso solo uno deja la linea.
  return `${code}Serial.println(${pin});\n`;
};

export const serial_blue = (block, generator) => {
  const content = generator.valueToCode(block, 'CONTENT', generator.ORDER_ATOMIC);
  const { code, pin } = findPinMode(content);
  generator.setups_['setup_serial'] = SERIAL_SETUP;
  return `${code}Serial.print(${pin});\n`;
};

export const serial_read = (block, generator) => {
  generator.setups_['setup_serial'] = SERIAL_SETUP;
  return ['Serial.read()', generator.ORDER_ATOMIC];
};

export const serial_special = (block, generator) => {
  const char = block.getFieldValue('CHAR');
  return [char, generator.ORDER_ATOMIC];
};

export const serial_available = (block, generator) => {
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');
  return `if (Serial.available()>0){\n${branch}\n}\n`;
};

// ------------------ Control por Bluetooth (SALIDAS_*) -----------------------

// Claves de definición constantes: el input 'PIN' del legacy es dummy y siempre
// resolvía a ''.
export const SALIDAS_buttons = (block, generator) => {
  const btn = (name) => generator.statementToCode(block, name).replace(/&quot;/g, '"');
  const btn1 = btn('BUTN1');
  const btn2 = btn('BUTN2');
  const btn3 = btn('BUTN3');
  const btn4 = btn('BUTN4');
  const btn5 = btn('BUTN5');
  const btn6 = btn('BUTN6');
  const btn7 = btn('BUTN7');

  generator.setups_['setup_buttons_'] = 'BT1.begin(9600);\n';
  generator.definitions_['declare_var_define_buttons'] = '#include <SoftwareSerial.h>\nSoftwareSerial BT1(9,8);   // RX, TX recordar que se cruzan\nchar command;\n';
  generator.definitions_['define_buttons'] = `void commandParser2(char command) {\n   char value[4];\n   switch(command){\n    case 'U':\n      ${btn1}\n      break;\n    case 'D':\n      ${btn2}\n      break;\n    case 'L':\n      ${btn3}\n      break;\n    case 'R':\n      ${btn4}\n      break;\n    case 'A':\n      ${btn5}\n      break;\n    case 'B':\n      ${btn6}\n      break;\n    case 'S':\n      ${btn7}\n      break; }\n}\n `;

  return 'if(BT1.available()) {\n   command = BT1.read();\n   commandParser2(command);\n}\n';
};

export const SALIDAS_scan_def = (block, generator) => {
  generator.definitions_['define_scan'] = '#include <Wire.h>\n';
  generator.setups_['setup_scan_'] = '  Wire.begin();\nSerial.begin(9600);\nwhile (!Serial);\nSerial.println("Escaner I2C ");\n';
  return '  byte error, address;\nint nDevices;\nSerial.println("Escaneando");\nnDevices = 0;\nfor(address = 1; address < 127; address++ )\n{\nWire.beginTransmission(address);\nerror = Wire.endTransmission();\nif (error == 0)\n{\nSerial.print("Dispositivo I2C encontrado en la direccion 0x");\nif (address<16)\nSerial.print("0");\nSerial.print(address,HEX);\nSerial.println("  !");\nnDevices++;\n}\nelse if (error==4)\n{\nSerial.print("Error desconocido en dirección 0x");\nif (address<16)\nSerial.print("0");\nSerial.println(address,HEX);\n}\n}\nif (nDevices == 0)\nSerial.println("No  se encontraron dispositivos I2C");\nelse\nSerial.println("terminado");\ndelay(5000);\n';
};
